export const FLOWS_LOAD_SUCCESS = 'FLOWS_LOAD_SUCCESS'
export const FLOW_LOAD_SUCCESS = 'FLOW_LOAD_SUCCESS'
export const FLOW_CREATE_SUCCESS = 'FLOW_CREATE_SUCCESS'


// flow steps
export const FLOW_STEP_EDIT_REQUEST = 'FLOW_STEP_EDIT_REQUEST'
export const FLOW_STEP_EDIT_SUCCESS = 'FLOW_STEP_EDIT_SUCCESS'
export const FLOW_STEP_EDIT_FAILED = 'FLOW_STEP_EDIT_FAILED'

export const FLOW_STEP_NEW_SUCCESS = 'FLOW_STEP_NEW_SUCCESS'
export const FLOW_STEP_DELETE_SUCCESS = 'FLOW_STEP_DELETE_SUCCESS'
